import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const CURRENT_STORE_KEY = 'current_store';

@Injectable({ providedIn: 'root' })
export class TokenService {
  constructor(private readonly cookieService: CookieService) {}

  saveAuthTokens(token: string, refreshToken: string) {
    this.cookieService.set(ACCESS_TOKEN_KEY, token, { path: '/' });
    this.cookieService.set(REFRESH_TOKEN_KEY, refreshToken, { path: '/' });
  }

  clear() {
    this.cookieService.delete(ACCESS_TOKEN_KEY, '/');
    this.cookieService.delete(REFRESH_TOKEN_KEY, '/');
  }

  getAccessToken() {
    return this.cookieService.get(ACCESS_TOKEN_KEY);
  }

  getCurrentStoreId() {
    return this.cookieService.get(CURRENT_STORE_KEY);
  }

  setCurrentStoreId(storeId: string) {
    this.cookieService.set(CURRENT_STORE_KEY, storeId, { path: '/' });
  }
}
